import { defineAsyncComponent } from 'vue';

const PUInvoiceDetail = defineAsyncComponent(() => import('@/views/purchase/pUInvoice/PUInvoiceDetail.vue'));
const PUPaymentDetail = defineAsyncComponent(() => import('@/views/purchase/pUPayment/PUPaymentDetail.vue'));
const ApproveVoucherPUPaymentTab = defineAsyncComponent(() =>
  import('@/views/purchase/pUPayment/ApproveVoucherPUPaymentTab.vue')
);

const ApproveVoucherPUInvoiceList = defineAsyncComponent(() =>
  import('@/views/purchase/pUInvoice/ApproveVoucherPUInvoiceList.vue')
);

const ViewQuantity = defineAsyncComponent(() => import('@/views/purchase/pUInvoice/ViewQuantity.vue'));

const PUVendorPaymentDetail = defineAsyncComponent(() =>
  import('@/views/purchase/pUVendorPayment/PUVendorPaymentDetail.vue')
);

const ApproveVoucherPUVendorPaymentTab = defineAsyncComponent(() =>
  import('@/views/purchase/pUVendorPayment/ApproveVoucherPUVendorPaymentTab.vue')
);
const CreateBUPlanWithdrawFromInBotListPopup = defineAsyncComponent(() =>
  import('@/views/purchase/invoicebot/CreateBUPlanWithdrawFromInBotListPopup.vue')
);
const CreatePUPaymentFromInbotListPopup = defineAsyncComponent(() => 
  import('@/views/purchase/invoicebot/CreatePUPaymentFromInbotListPopup.vue')
);
const InvoiceBotDetail = defineAsyncComponent(() =>
  import('@/views/purchase/invoicebot/InvoiceBotDetail.vue')
);
const ChooseVoucherInvoiceBotPopup = defineAsyncComponent(() =>
  import('@/views/purchase/invoicebot/ChooseVoucherInvoiceBotPopup.vue')
);

const TwoFactorAuthenInvoiceBot = defineAsyncComponent(() => 
  import('@/views/purchase/invoicebot/TwoFactorAuthenInvoiceBot.vue')
);


export function registerPU(app) {
  app.component('PUInvoiceDetail', PUInvoiceDetail);
  app.component('PUPaymentDetail', PUPaymentDetail);
  app.component('ApproveVoucherPUPaymentTab', ApproveVoucherPUPaymentTab);
  app.component('ApproveVoucherPUInvoiceList', ApproveVoucherPUInvoiceList);
  app.component('ViewQuantity', ViewQuantity);
  app.component('PUVendorPaymentDetail', PUVendorPaymentDetail);
  app.component('CreateBUPlanWithdrawFromInBotListPopup', CreateBUPlanWithdrawFromInBotListPopup);
  app.component('TwoFactorAuthenInvoiceBot', TwoFactorAuthenInvoiceBot);
  app.component('ApproveVoucherPUVendorPaymentTab', ApproveVoucherPUVendorPaymentTab);
  app.component('InvoiceBotDetail', InvoiceBotDetail);
  app.component('ChooseVoucherInvoiceBotPopup', ChooseVoucherInvoiceBotPopup);
  app.component('CreatePUPaymentFromInbotListPopup',CreatePUPaymentFromInbotListPopup);
}
